<template>
<div class="DangerManagement">
  <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <danger-drawer v-if="drawerShow" :editData="selectData" :handleType="handleType" :loading.sync="loading" @confirm="handleConfirm" @cancel="handleCancel"></danger-drawer>
  </el-drawer>
  <el-drawer title="处理详情" size="600px" :modal="false" :visible.sync="datailsShow" :wrapperClosable="false" direction="rtl" ref="drawer">
    <danger-details-drawer v-if="datailsShow" :datailsData="details"></danger-details-drawer>
  </el-drawer>
  <el-drawer title="新增隐患" size="600px" :modal="false" :visible.sync="addShow" :wrapperClosable="false" direction="rtl" ref="adddrawer">
    <add-danger-drawer v-if="addShow" :datailsData="addForm" @confirm="handleAddConfirm" @cancel="handleAddCancel"></add-danger-drawer>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <span>
        <el-select v-model="status" placeholder="是否注册" clearable>
          <el-option v-for="(item,i) in dealItem" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input v-model="searchText" autocomplete="off" placeholder="隐患标题|隐患描述" @keyup.enter.native="serachData"></el-input>
        <button v-if="rolePermit('danger:query')" class="primaryBtn" @click="serachData">查询</button>
        <button v-if="rolePermit('danger:del')" class="primaryBtn" @click="delAll">批量删除</button>
        <button v-if="rolePermit('danger:add')" class="primaryBtn" @click="addClick">上报隐患</button>
        <button v-if="rolePermit('danger:excel')" class="primaryBtn" @click="exportExcel"><span style="color:#fff">报表导出</span></button>
      </span>
    </div>
    <div class="tableBox">
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @selectionChange="handleSelectionChange" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
        <el-table-column type="selection" width="50" border></el-table-column>
        <el-table-column prop="title" label="隐患标题" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="" label="隐患位置" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div>{{scope.row.location}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="info" label="隐患描述" :show-overflow-tooltip="true"></el-table-column>        
        <el-table-column prop="" label="处理状态">
          <template slot-scope="scope">
            <div>{{scope.row.status == 0 ? '未处理' : '已处理'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="隐患现场图片">
          <template slot-scope="scope" v-if="scope.row.dangerThumbnail&&scope.row.dangerOriginal">
            <div><img :src="baseUrlAddr+scope.row.dangerThumbnail" alt="" style="cursor:pointer" @click="imgMask(scope.row.dangerOriginal)"></div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="风险等级">
          <template slot-scope="scope">
            <div>{{scope.row.riskLevel==0 ? '低风险' : scope.row.riskLevel ==1 ?'中风险' : scope.row.riskLevel == 2 ? '高风险' : '未知'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上报时间" width="160">
          <template slot-scope="scope">
            <p>{{scope.row.createTime}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="上报人" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="" label="操作" width="250" v-if="rolePermit('danger:handle')||rolePermit('danger:query')||rolePermit('danger:del')">
          <template slot-scope="scope">
            <el-button type="text" v-if="(scope.row.status==0||scope.row.status==1)&&rolePermit('danger:handle')" icon="el-icon-s-claim" @click="editClick(scope.row)">处理</el-button>
            <el-button type="text" v-if="scope.row.status==2&&rolePermit('danger:query')" icon="el-icon-reading" @click="detailClick(scope.row)">详情</el-button>
            <el-button style="color:#DD3071" v-if="rolePermit('danger:del')" type="text" icon="el-icon-delete" @click="delClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
  <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
// 隐患处理
import DangerDrawer from "@/components/hiddenDangerManagement/DangerDrawer";
// 隐患处理详情
import DangerDetailsDrawer from "@/components/hiddenDangerManagement/DangerDetailsDrawer";
// 新增隐患
import AddDangerDrawer from "@/components/hiddenDangerManagement/AddDangerDrawer";

import axios from 'axios';
export default {
  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "暂无时间";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times =
          d.getFullYear() +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          min +
          ":" +
          sec;
        return times;
      }
    }
  },
  components: {
    BorderTable,
    DangerDrawer,
    DangerDetailsDrawer,
    AddDangerDrawer
  },
  data() {
    return {
      imgUrl: '',
      showImg: false,
      status: '',
      loading: false,
      drawerShow: false,
      styleObject: {
        height: ""
      },
      dealItem: [{
          label: '全部',
          value: ''
        },
        {
          label: '未处理',
          value: 0
        },
        {
          label: '已处理',
          value: 2
        }
      ],
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      drawerTitle: "",
      drawerWidth: "600px",
      // orgId: this.storage.getSession("orgId"),
      searchText: "",
      handleType: '',
      checkDatas: [],
      selectData: {},
      details: {},
      datailsShow: false,
      addShow: false,
      addForm: {}
    };
  },

  created() {
    this.makeheight();
    this.initData()
  },
  provide() {
    return {
      pinitdata: this.initData
    }
  },
  methods: {
    //图片放大
    imgMask(data) {
      this.imgUrl = this.baseUrlAddr + data
      this.showImg = true
    },
    initData() {
      this.tableLoading = true;
      let setParams = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        keyWord: this.searchText ? this.searchText : null,
        status: this.status,
      }
      this.request.get("/front/danger/query", setParams).then(res => {
        console.log(11111, res)
        this.tableLoading = false;
        if (res.code == 200) {
          this.dataList = res.data?res.data:[]
          this.pagination.total = res.total;
        } else if (res.code == 500) {
          this.msg.warn(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })

    },
    editClick(row) {
      //处理隐患
      this.selectData = row
      this.drawerShow = true;
      this.drawerTitle = "处理隐患";
      this.handleType = "edit";
    },
    stopClick(row) {
      this.$confirm("此操作将暂缓处理隐患, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.put("/front/danger/postHandle/" + row.id).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "暂缓处理隐患成功!",
              });

              this.initData();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消暂缓处理隐患",
          });
        });
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.delete("/front/danger/delete?ids=" + row.id).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addClick() {
      this.addShow = true;
    },
    detailClick(row) { //详情
      // console.log(row)
      this.request.get("/front/danger/handle/queryByDangerId?dangerId=" + row.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.details = res.data
          this.datailsShow = true
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      });
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    handleConfirm(data) { //确认
      console.log(data)
      if (data == 200) {
        this.drawerShow = false
        this.initData()
      }
    },
    handleCancel(data) { //取消
      console.log(data)
      this.drawerShow = false
    },
    handleAddConfirm(data) {
      if (data == 200) {
        this.addShow = false
        this.initData()
      }
    },
    handleAddCancel(data) {
      this.addShow = false
    },
    serachData() {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "");
      this.pagination.currentPage = 1;
      this.initData();
    },
    handleSelectionChange(data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
    delAll() {
      //批量删除
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选删除内容！")
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].id)
        }
        this.arry = arr
        console.log(this.arry)
        let params = {
          ids: this.arry.toString()
        }
        this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.delete("/front/danger/delete", params).then(res => {
            // console.log(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              let num = ''
              if (this.pagination.total > this.pagination.pageSize) {
                num = (this.pagination.total - this.checkDatas.length) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    //报表导出
    exportExcel() {
      this.$confirm('此操作将导出报表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.open(this.baseUrlAddr + '/front/danger/export?'+(this.searchText ? 'keyWord=' + this.searchText : '') + (this.status==0||this.status ? '&status=' + this.status : ''))
        this.msg.success('导出成功')
        return
      }).catch(() => {
        this.msg.info('已取消导出')
      });
      // this.$confirm(
      //   "没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续?",
      //   "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }
      // ).then(() => {
      //   window.open(this.baseUrlAddr + '/front/danger/export?page=' + this.pagination.currentPage + '&pageSize=' + this.pagination.pageSize + (this.searchText ? '&keyWord=' + this.searchText : '') + (this.status ? '&status=' + this.status : ''))
      // });
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.initData()
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.initData()
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.DangerManagement {
  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }

    // .btnS{
    //    color: #2A7EE1;
    //    border:1px solid #A1C6F3;
    //    background: #EFF3FC;
    //    margin-right:24px;
    //    &:hover{

    //    }
    // }
  }

  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 50px;
      cursor: pointer;
    }

    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
    }

    .imgMask {
      // width: 600px;
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      // margin-top: -300px;
      // margin-left: -300px;
      transform: translate(-50%, -50%);
      background: #fff;

      img {
        // width: 100%;
        height: 100%;
      }
    }
  }
}
</style><style lang="scss">
.DangerManagement {
  .mainContent {
    .query {
      .el-input {
        width: 380px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }
  }
}
</style>
